import { ReactNode } from 'react';
import { WorkflowLayoutsStore } from './WorkflowLayoutsStore';

const workflowLayouts = {
    DefaultLayout: ({ children }: { children: ReactNode }) => (
        <div data-testid="default-layout">{children}</div>
    ),
    FinalStepLayout: ({ children }: { children: ReactNode }) => (
        <div data-testid="final-step-layout">{children}</div>
    ),
};

export const WorkflowLayoutsTestProvider = ({ children }: { children: ReactNode }) => {
    return (
        <WorkflowLayoutsStore.Provider initialState={workflowLayouts}>
            {children}
        </WorkflowLayoutsStore.Provider>
    );
};
